export default "__VITE_PUBLIC_ASSET__17927c26__"